//Libraries
import {FC} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

//Typing
import {IDIRecord} from 'src/types/org/di/diInterface';
import {APP_URLS} from 'src/constants';

//Components
import {DiProfileEditForm} from 'src/containers/school/operations/di/diProfileEditForm';
import {Loader} from 'src/generic/component';

/**
 * This component is only responsible for extracting
 * the org and di data from the navigation and instantiating
 * the DiProfileEditForm.
 */
export const DiProfileEditPage: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state as any;
    const record = state?.record as IDIRecord;

    if (record) {
        return <DiProfileEditForm onComplete={() => {
            navigate(APP_URLS.DIPROFILE, {
                state: {
                    diCode: record.di.diCode,
                    orgId: record.org.orgId,
                    type: 'di'
                }
            });
        }} onClose={() => {
            navigate(APP_URLS.DIPROFILE, {
                state: {
                    diCode: record.di.diCode,
                    orgId: record.org.orgId,
                    type: 'di'
                }
            });
        }} record={record}></DiProfileEditForm>;
    } else {
        return <Loader></Loader>;
    }
};